import { Component, TemplateRef } from '@angular/core';
import { LoaderComponent } from '../../../components/layout/loader/loader.component';
import { CommonModule } from '@angular/common';
import { Router, ActivatedRoute } from '@angular/router';
import { ApiService } from '../../../services/api.service';
import { UserInformationFormComponent } from '../../../components/user-information-form/user-information-form.component';
import { ModalDismissReasons, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { TableGuruComponent } from "../../../components/table-guru/table-guru.component";
import { LicenseFormComponent } from '../../../components/user/license-form/license-form.component';

import { TabComponent } from '../../../components/tab/tab.component';
import { TabGroupComponent } from '../../../components/tab-group/tab-group.component';

import { DutchDatePipe } from '../../../pipes/dutch-date.pipe';
import { FormsModule } from '@angular/forms';

@Component({
  selector: 'app-user-detail',
  standalone: true,
  imports: [
    DutchDatePipe,
    CommonModule,
    UserInformationFormComponent,
    LoaderComponent,
    FormsModule,
    TableGuruComponent,
    TabComponent,
    TabGroupComponent
  ],
  templateUrl: './user-detail.component.html',
  styleUrl: './user-detail.component.scss'
})
export class UserDetailComponent {
  loading: boolean = false;
  item: any | null = null;
  eduvData: any | null = null;
  entitlementCodes: any | null = null;

  itemId: string | null = null;
  portalClientId: string | null = null;
  entitlementPreview: string | null = null;
  
  entitlementId: string | null = null;
  userLicences: [] = [];
  userRights: [] = [];
  scopes: [] = [];
  clients: [] = [];

  selectedRole: any = null;
  selectedScopes: string[] = this.scopes[this.selectedRole] || [];

  constructor(
    private router: Router,
    private modalService: NgbModal,
    private activatedRoute: ActivatedRoute,
    private apiService: ApiService
  ) {
    let self = this;
    this.loading = true;

    this.itemId = this.activatedRoute.snapshot.paramMap.get('id');

    this.getItem().then(function () {
      self.getEntitlementCodes();
    });
    this.getLicenses();
    this.getClients();
    this.getScopes();
  }

  ngOnChanges(changes: any) {
  }

  updateRole(roleKey: any): void {
    this.selectedRole = roleKey;
    this.selectedScopes = this.scopes[roleKey] || [];
    this.item.role_key = roleKey;
  }

  getObjKeys(obj: any) {
    return Object.keys(obj)
  }

  toggleScope(scope: string): void {
    if (this.selectedScopes.includes(scope)) {
      this.selectedScopes = this.selectedScopes.filter(s => s !== scope);
    } else {
      this.selectedScopes.push(scope);
    }
  }

  addLicense() {
    let self = this;
    const modalRef = this.modalService.open(LicenseFormComponent, {
      size: 'lg'
    });
    modalRef.componentInstance.modalStyle = true;
    modalRef.componentInstance.userId = self.item['id'];
    modalRef.componentInstance.organisationId = self.item['organisation_id'];
    modalRef.componentInstance.modalInstance = modalRef;

    modalRef.result.then((result) => {
      this.getLicenses();
    });
  }

	openAddCode(content: TemplateRef<any>, entitlementId:string) {
    let self = this;
    self.entitlementId = entitlementId;
		this.modalService.open(content, { 
      size: 'lg',
      ariaLabelledBy: 'modal-basic-title' 
    }).result.then(
			(result) => {
        self.getEntitlementCodes();
			},
			(reason) => {
        self.getEntitlementCodes();
			},
		);
	}

	openPreview(content: TemplateRef<any>, entitlementId:string) {
    let self = this;
    self.entitlementId = entitlementId;
    self.getPreview(entitlementId);
		this.modalService.open(content, { 
      size: 'lg',
      ariaLabelledBy: 'modal-basic-title' 
    }).result.then(
			(result) => {
       
			},
			(reason) => {
        
			},
		);
	}

  open(content: TemplateRef<any>) {
    let self = this;
    this.modalService.open(content, {
      size: 'lg',
      ariaLabelledBy: 'modal-basic-title'
    }).result.then(
      (result) => {
        self.getItem();
      },
      (reason) => {
        self.getItem();
      },
    );
  }

  getClients() {
    let self = this;
    return this.apiService.get('/office/clients?limit=500').then(function (response: any) {
      self.clients = response['data'];
      setTimeout(function () { self.loading = false; }, 200);
    }).catch(function (e) {
      self.loading = false;
    });
  }

  getLicenses() {
    let self = this;
    return this.apiService.get('/office/users/' + this.itemId + "/user-licenses").then(function (response: any) {
      self.userLicences = response;
      setTimeout(function () { self.loading = false; }, 200);
    }).catch(function (e) {
      self.loading = false;
    });
  }

  getEntitlementCodes() {
    let self = this;
    return this.apiService.get('/office/entitlement-codes?user_id=' + self.item['id'] + "&limit=500").then(function (response: any) {
      self.entitlementCodes = response['data'];
      setTimeout(function () { self.loading = false; }, 200);
    }).catch(function (e) {
      self.loading = false;
    });
  }

  getScopes() {
    let self = this;
    return this.apiService.get('/office/users/scopes').then(function (response: any) {
      self.scopes = response;
      setTimeout(function () { self.loading = false; }, 200);
    }).catch(function (e) {
      self.loading = false;
    });
  }

  getItem() {
    let self = this;
    return this.apiService.get('/office/users/' + this.itemId).then(function (response: any) {
      self.item = response;
      self.selectedRole = self.item.role_key;
    }).catch(function (e) {
      self.loading = false;
    });
  }

  saveRole() {
    this.apiService.put("/office/users/" + this.itemId + "/rights", {
      role_id: this.item.role_id,
      scopes: this.selectedScopes
    });
  }

  formatJson(jsonText: any) {
    if (!jsonText || jsonText == "") {
      return "";
    }
    try {
      const obj = JSON.parse(jsonText);
      return JSON.stringify(obj, null, 2) ?? jsonText;
    } catch (error) {
      return "" + jsonText;
    }
  }

  getEduV() {
    let self = this;
    return this.apiService.get('/office/users/' + this.itemId + '/eduv/info').then(function (response: any) {
      self.eduvData = JSON.stringify(response);
    }).catch(function (e) {
      self.loading = false;
    });
  }

  getPreview (entitlementId:string) {
    let self = this;
    return this.apiService.get('/office/entitlements/' + entitlementId + '/eduv/preview').then(function (response: any) {
      self.entitlementPreview = JSON.stringify(response);
    }).catch(function (e) {
      self.loading = false;
    });
  }

  syncEntitlement(entitlementId:string) {
    let self = this;
    self.loading = true;

    const modal = document.querySelector('.modal');
    if (modal) {
      modal.scrollTo({ top: 0, behavior: 'smooth' });
    }

    return this.apiService.get('/office/entitlements/' + entitlementId + '/eduv/sync').then(function (response: any) {
      self.entitlementPreview = JSON.stringify(response);
      self.loading = false;
      self.getEntitlementCodes();
    }).catch(function (e) {
      self.loading = false;
    });
  }

  blockEntitlement(entitlementId:string) {
    let self = this;
    self.loading = true;

    const modal = document.querySelector('.modal');
    if (modal) {
      modal.scrollTo({ top: 0, behavior: 'smooth' });
    }

    return this.apiService.get('/office/entitlements/' + entitlementId + '/block').then(function (response: any) {
      self.entitlementPreview = JSON.stringify(response);
      self.loading = false;
      self.getEntitlementCodes();
    }).catch(function (e) {
      self.loading = false;
    });
  }

  redeemEntitlement(entitlementId:string, entitlementCodeId:string) {
    let self = this;
    self.loading = true;

    const modal = document.querySelector('.modal');
    if (modal) {
      modal.scrollTo({ top: 0, behavior: 'smooth' });
    }

    return this.apiService.get('/office/entitlements/' + entitlementId + '/redeem?userId='+this.item['id']+'&entitlementCodeId=' + entitlementCodeId).then(function (response: any) {
      self.entitlementPreview = JSON.stringify(response);
      self.loading = false;
      self.getEntitlementCodes();
    }).catch(function (e) {
      self.loading = false;
    });
  }

  saveEntitlement() {
    let self = this;
    self.loading = true;

    const modal = document.querySelector('.modal');
    if (modal) {
      modal.scrollTo({ top: 0, behavior: 'smooth' });
    }

     let postData : any = {};
     postData['userId'] = this.item.id;
     postData['entitlementId'] = self.entitlementId;
     postData['portalClientId'] = self.portalClientId;
      
      return this.apiService.post('/office/entitlement-codes', postData).then(function (response: any) {
        self.modalService.dismissAll();
      }).catch(function (e) {
      });
  }
}
